<script setup lang="ts">
const carousels = [
  {
    title: 'Buat Paket Instant',
    description:
      'Masukkan data pengiriman paketmu, kamu bisa kirim ke 1 tujuan saja atau hingga 5 tujuan sekaligus. Tentukan jenis kendaraan motor atau mobil sesuai berat paketmu.'
  },
  {
    title: 'Pilih Pengiriman Instant',
    description:
      'Tentukan layanan pengiriman instant pilihanmu dari berbagai ekspedisi yang tersedia di KiriminAja.'
  },
  {
    title: 'Pesan dan Lacak Pengiriman',
    description:
      'Setelah semua detail terisi, pesan pengiriman agar driver segera menjemput paketmu. Kamu dapat melacak posisi driver secara real-time hingga paket tiba di tujuan.'
  }
]
</script>

<template>
  <div class="bg-surface-container-low py-7 lg:py-16 relative overflow-hidden">
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-11 relative z-10">
      <UiSectionTitle
        class="text-center"
        title="Cara Kirim Paket Instant, Praktis dan Bisa<br />Disesuaikan dengan Perangkatmu"
        description="Kamu bisa kirim paket instant melalui aplikasi atau dashboard
KiriminAja dengan beberapa langkah mudah."
      />
      <UiCarouselFeature :items="carousels" />
    </UiContainer>
  </div>
</template>
